<template>
  <BaseGhostContainer v-bind="$attrs">
    <div class="btn" :style="bgStyleObj" @click="handleClick"></div>
  </BaseGhostContainer>
</template>

<script>
import BaseGhostContainer from './BaseGhostContainer';
export default {
  props: {
    buttonImage: String
  },
  computed: {
    bgStyleObj() {
      return {
        background: `center / contain url("${this.buttonImage}") no-repeat`
      };
    }
  },
  components: { BaseGhostContainer },
  methods: {
    handleClick() {
      this.$emit('reportEvent', {
        event: 'component_button_click',
        module_name: '活动规则（自定义）'
      });
      this.$router.push('/rule');
    }
  },
  mounted() {
    this.$emit('reportEvent', {
      event: 'component_expo',
      module_name: '活动规则（自定义）'
    });
  }
};
</script>

<style lang="less" scoped>
.btn {
  width: 88px;
  height: 88px;
}
</style>
